import { useState, useEffect } from "react";
export default function useOneArticle(blogId) {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  // Variables d'environnement sécurisées
  /* eslint-disable no-undef */
  const COSMIC_BUCKET = process.env.NEXT_PUBLIC_COSMIC_BUCKET_SLUG;
  const COSMIC_READ_KEY = process.env.NEXT_PUBLIC_COSMIC_READ_KEY;
  /* eslint-enable no-undef */

  // URL de base selon l'environnement
  const API_BASE_URL = "https://api.cosmicjs.com";

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/v3/buckets/${COSMIC_BUCKET}/objects?read_key=${COSMIC_READ_KEY}&query=${encodeURIComponent(
            '{"id":"' + blogId + '"}'
          )}&props=id,title,metadata&depth=1`
        );
        const cetArticle = await response.json();
        if (cetArticle.objects && cetArticle.objects.length > 0) {
          setArticle(cetArticle.objects[0]);
          setError("");
        } else {
          setError("Article non trouvé.");
        }
      } catch (error) {
        setError("Erreur lors de la récupération de l'article.");
        console.error(error);
      }
      setLoading(false);
    };
    fetchArticle();
  }, [blogId]);

  return { article, loading, error };
}
